const translations = {
  'graduates.seo.title': 'TEFL Iberia Reviews & Testimonials from Graduates',
  'graduates.seo.description':
    'Read reviews and testimonials from previous Tefl Iberia students and graduates, and apply to become a student online.',
  'graduates.sec1.title': 'TEFL Iberia Graduates',
  'graduates.sec1.description':
    'We love creating memorable experiences here at TEFL Iberia. We pride ourselves on providing high-quality training, an essential support system and most importantly a life changing opportunity to work abroad. Hear it from our graduates first hand:',
  'graduates.sec1.benTitle': 'In the videos the graduates highlight:',
  'graduates.sec1.ben1': 'Feeling confident to stand in front of a class and teach',
  'graduates.sec1.ben2': 'Teaching real students',
  'graduates.sec1.ben3': 'Finding a job quickly after the course',
  'graduates.sec2.modalTitle': 'Follow us on social media and keep up to date with student Life',
  'graduates.sec2.modalDescription': 'Keep up to date with our students on Instagram',
};

export default translations;
